import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * @file
 * @module Pages/Error
 * @description Error est une page qui affiche un message d'erreur lorsque l'utilisateur tente d'accéder à une page qui n'existe pas.
 * Elle affiche un message d'erreur 404 et un lien pour retourner à la page d'accueil.
 */

const Error = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center">
            <div className="container-responsive section-padding">
                <div className="max-w-2xl mx-auto text-center">
                    <div className="card">
                        <div className="text-8xl font-bold text-primary mb-6">404</div>
                        <h1 className="text-3xl font-bold text-gray-800 mb-4">Oups !</h1>
                        <h2 className="text-xl text-gray-600 mb-8">La page que vous demandez n'existe pas</h2>
                        <p className="text-gray-500 mb-8">
                            Il semble que vous ayez suivi un lien cassé ou que la page ait été déplacée.
                        </p>
                        <NavLink 
                            to={"/"} 
                            className="btn-primary inline-flex items-center"
                        >
                            <i className="fas fa-home mr-2"></i>
                            Retourner sur la page d'accueil
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error;